import React, { useState } from 'react'
import './HomeNavigation.css'
import HomeHeader from './HomeHeader'
//import Footer from '../UIElements/Footer'
import HomeNavLinks from './HomeNavLinks'
import SideDrawer from '../../../admin/components/SideDrawer'
import Backdrop from '../UIElements/Backdrop'
import playerStatsLogo from '../../../images/playerPages_transparent.png'

const PlayerHistoryHomeNavigation = (props) => {
	console.log('inside PlayerHistoryHomeNavigation: ' + props.leagueId)

	const [drawerIsOpen, setDrawerIsOpen] = useState(false)

	const openDrawerHandler = () => {
		setDrawerIsOpen(true)
	}

	const closeDrawerHandler = () => {
		setDrawerIsOpen(false)
	}

	return (
		<React.Fragment>
			{drawerIsOpen && <Backdrop onClick={closeDrawerHandler} />}
			<SideDrawer show={drawerIsOpen} onClick={closeDrawerHandler}>
				<nav className='home-navigation__drawer-nav'>
					<HomeNavLinks leagueId={props.leagueId} />
				</nav>
			</SideDrawer>
			<HomeHeader>
				<button
					className='home-navigation__menu-btn'
					onClick={openDrawerHandler}
				>
					<span />
					<span />
					<span />
				</button>
				{/* <h1
					className='home-navigation__title'
					style={{ textShadow: 'black 2px 2px 2px' }}
				>
					Player Stats
				</h1> */}
				<div className='headerWidth'>
					<img src={playerStatsLogo} className='playerStatsLogo' />
				</div>
				<nav className='home-navigation__header-nav'>
					<HomeNavLinks leagueId={props.leagueId} />
				</nav>
			</HomeHeader>
		</React.Fragment>
	)
}

export default PlayerHistoryHomeNavigation
